function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50",
  height: "5000",
  width: "5000"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "#301863"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 7C13.1 2.5 4.5 7 6.7 13.8c1.5 4.8 8.8 7.9 17.3 12.3 4.5-8.5 8.7-15.2 7.2-20C29-.7 19.5.6 18 7z",
  fill: "#ff7083"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 49.3h-.6l-24.6-4h-.4c-.6 0-1.2.2-1.6.6l-1 .6c-.6.5-1.4.9-2.2.9H14l-4.4-.7c-1-.2-1.8-.7-2.3-1.6l-.6-1c-.3-.6-1-1.1-1.7-1.2l-2.1-.3c-1.5-.2-2.5-1.5-2.2-3v-.2l1.8-11.5c.1-1.3 1.2-2.3 2.5-2.3.2 0 .4 0 .6.1l2.1.3c1 .2 1.8.9 2.3 1.7l.6 1c.3.6 1 1.1 1.7 1.3l4.4.6h.4c.5 0 1.2-.3 1.6-.6l1-.6c.6-.5 1.4-.9 2.2-.9h.5l24.6 4c.7.1 1.5.4 1.9 1.1.4.6.5 1.4.4 2.1l-1.8 11.4c-.2 1.3-1.3 2.2-2.5 2.2z",
  fill: "#ffbf00"
}))));